import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import DataObjectIcon from '@mui/icons-material/DataObject';
import classes from "./maintainerStyles.module.scss"
import { useContext, useState } from "react";
import SessionJsonModalPopup from "./SessionJsonModalPopup";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import DeleteIcon from '@mui/icons-material/Delete';
import { UserUIStateContext } from "../../store/userUIStateContext";
import CachedIcon from '@mui/icons-material/Cached';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import SetUserRolesModal from "./SetUserRolesModal";
import { ThemeContext, Themes } from "../../store/ThemeContext";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const MaintainerTools = () =>{
    const {theme, changeTheme} = useContext(ThemeContext);
    const [jsonOpened, setJsonOpened] = useState(false);
    const [userRolesOpened, setUserRolesOpened] = useState(false);
    const [sessionJson, setSessionJson] = useState();
    const { rowId } = useContext(UserUIStateContext);
    const onSessionJsonClick = () =>{
        ddd.GetSessionInfo({includeExtendedInfo : true}).then(res => {
            setSessionJson(res);
        });
        setJsonOpened(true)
    }

    const onDeleteUIStatesClick = () =>{
        if(!rowId)
            return console.row("No row Id found");
        const dataTable = new E2Data("EU_UI_AdminTransfomer");
        dataTable.values = {UI_Variables : "{}"};
        dataTable.filter = `Id="${rowId}"`
        dataTable.Modify();
    }

    const onClearSessionCacheClick = () => {
        ddd.InvalidateSessionExtensions();
    }

    const openLoadSpecificUserRolesModal = () =>{
        setUserRolesOpened(true);
    }

    const onChangeThemeClick = () => {
        if(theme === Themes.Default) return changeTheme(Themes.Red);
        changeTheme(Themes.Default);
        /*if(theme === "dark"){
            setTheme("light");
            document.body.className = "light";
        }else{
            setTheme("dark");
            document.body.className = "dark"; 
        }*/
    }

    return (
        <>
        <div>
            {/* <OverlayTrigger placement="bottom" overlay={<Tooltip>Change theme</Tooltip>}>
                <DataObjectIcon style={{fontSize:"2.5rem"}} className={classes["icon"]} onClick={onChangeThemeClick}/>
            </OverlayTrigger> */}
            {/* <select onChange={(e) => changeTheme(e.target.value)}>
                <option value={Themes.Default}>Default</option>
                <option value={Themes.Red}>Red</option>
                <option value={Themes.Organization}>Organization</option>
            </select> */}
            <OverlayTrigger placement="bottom" overlay={<Tooltip>See session info</Tooltip>}>
                <DataObjectIcon style={{fontSize:"2.5rem"}} className={classes["icon"]} onClick={onSessionJsonClick}/>
            </OverlayTrigger>
            <SessionJsonModalPopup show={jsonOpened} sessionJson={sessionJson} onHide={() => setJsonOpened(false)}/>
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Delete UI states (EU_UI_AdminTransfomer). Refesh page after.</Tooltip>}>
                <DeleteIcon style={{fontSize:"2.5rem"}} className={classes["icon"]} onClick={onDeleteUIStatesClick}/>
            </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Clear extended session cache</Tooltip>}>
                <CachedIcon style={{fontSize:"2.5rem"}} className={classes["icon"]} onClick={onClearSessionCacheClick}/>
            </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Load specific user roles</Tooltip>}>
                <SupervisedUserCircleIcon style={{fontSize:"2.5rem"}} className={classes["icon"]} onClick={openLoadSpecificUserRolesModal}/>
            </OverlayTrigger>
            <SetUserRolesModal show={userRolesOpened} onHide={() => setUserRolesOpened(false)}/>
        </div>
        </>
    )
}

export default MaintainerTools;